module.exports = __webpack_public_path__ + "img/ESTP.47e7dcfa.png";